export default {"src":"https://s.sylndr.com/c-f6814a1/_next/static/media/NewlyAddedAr.1262456f.svg","height":48,"width":70,"blurWidth":0,"blurHeight":0};